import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IFieldsPicker {
    open?: boolean;
    setOpen: (v: boolean) => void;
    fields?: string[];
    setAxes: (v: {x: string; y: string;}) => void;
    setChart: (v: 'chart' | 'table') => void;
}

const FieldsPicker: React.FC<IFieldsPicker> = ({ open = false, fields, setOpen, setAxes, setChart }) => {
    const [x, setX] = useState('')
    const [y, setY] = useState('')

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleClose = () => {
        setOpen(false);
        setAxes({x, y})
    };

    const handleSave = () => {
        if (!x || !y) return
        setChart('chart')
        setOpen(false);
        setAxes({x, y})
    };

    const handleChangeX = (event: SelectChangeEvent) => {
        let _x = event.target.value as string
        if (_x === y) _x = ''

        setX(_x)
    };

    const handleChangeY = (event: SelectChangeEvent) => {
        let _y = event.target.value as string
        if (_y === x) _y = ''

        setY(_y)
        setAxes({x, y})
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Set X and Y Axes?"}</DialogTitle>
                <DialogContent>
                        <InputLabel id="x-label">X Axis</InputLabel>
                        <Select
                            labelId="x-label"
                            value={x}
                            label="X Axis"
                            fullWidth
                            onChange={handleChangeX}
                        >
                            {fields?.map(f => (<MenuItem key={f} value={f}>{f}</MenuItem>))}
                        </Select>
                        <InputLabel sx={{mt: 2}} id="y-label">Y Axis</InputLabel>
                        <Select
                            labelId="y-label"
                            value={y}
                            label="Y Axis"
                            fullWidth
                            onChange={handleChangeY}
                        >
                            {fields?.map(f => (<MenuItem key={f} value={f}>{f}</MenuItem>))}
                        </Select>
                </DialogContent>
                <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default FieldsPicker